module.exports = __webpack_public_path__ + "img/制御工学5_5_3.f0f3f2c0.png";